import { render } from "./KafedraOqituvchilari.vue?vue&type=template&id=27cdc818&scoped=true"
import script from "./KafedraOqituvchilari.vue?vue&type=script&lang=js"
export * from "./KafedraOqituvchilari.vue?vue&type=script&lang=js"

import "./KafedraOqituvchilari.vue?vue&type=style&index=0&id=27cdc818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cdc818"]])

export default __exports__